import React from 'react';
import '../styles/PlayersList.css';

function PlayersList({ players, currentPlayerId }) {
    // Sort players by score (highest first)
    const sortedPlayers = [...players].sort((a, b) => b.score - a.score);

    return (
        <div className="players-list">
            <h3>Players</h3>
            <ul>
                {sortedPlayers.map((player) => (
                    <li
                        key={player.id}
                        className={`player-item ${player.id === currentPlayerId ? 'current-player' : ''} ${!player.isAlive ? 'dead-player' : ''}`}
                    >
                        <div
                            className="player-color"
                            style={{ backgroundColor: player.color }}
                        />
                        <span className="player-name">
              {player.name}
                            {player.id === currentPlayerId && " (You)"}
            </span>
                        <span className="player-score">{player.score}</span>
                        {!player.isAlive && <span className="player-status">DEAD</span>}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default PlayersList;
